import { Form } from "@/react/components/shared/uikit/Form";
import { Typography } from "@/react/components/shared/uikit/Typography";
import { Header } from "../../components/Header";

interface HeaderFormProps {
  dataTestId?: string;
  titleLocale: string;
  toggleName?: string;
}

export const HeaderForm = ({
  titleLocale,
  toggleName,
  dataTestId,
}: HeaderFormProps) => (
  <Header className="flex flex-row items-center justify-between px-6 py-4">
    <Typography.LabelSm weight="semibold">{titleLocale}</Typography.LabelSm>
    {toggleName && (
      <Form.ToggleSwitch
        name={toggleName}
        variant="large"
        dataTestId={dataTestId}
      />
    )}
  </Header>
);
